var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col items-center"},[_c('div',{staticClass:"w-full px-5"},[(_vm.$route.meta.breadcrumb)?_c('VxBreadcrumb',{staticClass:"my-5"}):_vm._e(),_c('BookingComponent',{attrs:{"id":_vm.$route.params.bookingID}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }